<template>
    <ValidationProvider
        class="relative appearance-none"
        tag="div"
        :vid="vid"
        :rules="rules"
        :name="name"
        :mode="mode"
        v-slot="{ errors, required, ariaInput, ariaMsg }"
    >
        <fieldset
            ref="fieldset"
            :class="[{ 'hasError': errors[0]}, fieldsetClass]"
            :disabled="disabled"
            v-tooltip.top-end="{
                content: errors[0],
                template: tooltipTemplate(),
            }"
        >
            <slot/>
        </fieldset>
    </ValidationProvider>
</template>

<script>

export default {
    name: "VeeFieldset",
    props: {
        disabled: {
          type: Boolean,
          default: false
        },
        vid: {
            type: String,
            default: undefined
        },
        name: {
            type: String,
            default: ""
        },
        mode: {
            type: String,
            default: "lazy"
        },
        rules: {
            type: [Object, String],
            default: ""
        },
        fieldsetClass: {
          default: '',
          required: false
        },
    },
    methods: {
      tooltipTemplate ()  {
          return `<div class="tooltip" role="tooltip"><div class="tooltip-arrow hasError"></div><div class="tooltip-inner hasError"></div></div>`;
      }
    },
};
</script>

<style lang="scss">

.tooltip-inner.hasError {
    text-shadow: none !important;
    border-color: #d04444 !important;
    background-color: #d04444 !important;
    box-shadow: 4px 4px 8px #dd4b3973 !important;
}
.tooltip-arrow.hasError {
    border-color: #d04444 !important;
}
</style>
